import React from 'react'
import './StaleNarrativeBanner.css'

interface Props {
  mode?: 'legacy' | 'inputs-changed'
  inputsChangedAt?: string
  onRefreshClick: () => void
}

function formatInputsChangedAt(iso?: string): string {
  if (!iso) return 'recently'
  try {
    const d = new Date(iso)
    return d.toLocaleString(undefined, {
      month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
    })
  } catch {
    return 'recently'
  }
}

export const StaleNarrativeBanner: React.FC<Props> = ({
  mode = 'legacy',
  inputsChangedAt,
  onRefreshClick,
}) => (
  <div className="stale-narrative-banner" role="status" aria-live="polite">
    <p>
      {mode === 'inputs-changed' ? (
        <>
          Your edits at <strong>{formatInputsChangedAt(inputsChangedAt)}</strong> aren't reflected in the narratives below. Refresh to update.
        </>
      ) : (
        <>
          This report's narrative was written before live targets shipped.
          Numeric details inside the prose may not reflect the current Key Results below.
        </>
      )}
    </p>
    <button type="button" className="stale-narrative-regenerate" onClick={onRefreshClick}>
      Refresh Narratives
    </button>
  </div>
)
